<template>
  <div :class="customClass" v-click-outside="closeOutside">
    <button type="button" :class="[{'is-open': active}, customButtonClass]"
            @click="toggleState()" :aria-expanded="active ? 'true' : 'false'">
      <!-- If icon is passed -->
      <div v-if="icon" class="c-icon-label">
        <svgicon v-if="icon" :name="icon" :width="iconWidth" :height="iconHeight"></svgicon>
        <span class="c-icon-label__content"><slot name="toggle-button"></slot></span>
      </div>

      <!-- If no icon is passed -->
      <span v-if="!icon"><slot name="toggle-button"></slot></span>

      <!-- Arrow down icon -->
      <svgicon v-if="arrowIcon" class="svg-down" name="arrow-rounded" width="5.5" height="5"></svgicon>
    </button>

    <!-- Toggle content -->
    <div :class="contentClass" v-show="active">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import vClickOutside from 'v-click-outside';

  // Register outside Click plugin
  Vue.use(vClickOutside);

  export default {
    methods: {
      toggleState() {
        this.active = !this.active;
        this.$emit('input', this.active);
      },

      closeToggle() {
        this.active = false;
      },

      closeOutside() {
        if (this.outside) this.closeToggle();
      },

      openToggle() {
        this.active = true;
      },
    },
    mounted() {
      document.addEventListener("keydown", (e) => {
        if (this.active && e.keyCode === 27) {
          if (this.escape) this.closeToggle();
        }
      });
    },
    created() {
      this.active = this.open;
    },
    ready() {
      // Open Toggle if prop open is set to True.
      if (this.active) {
        this.$emit('openToggle')
      }
    },
    data() {
      return {
        active: false
      }
    },
    props: {
      'custom-button-class': String,
      'custom-class': [String, Object],
      'icon': String,
      'iconWidth': String,
      'iconHeight': String,
      'open': {type: Boolean},
      'outside': {type: Boolean, default: true},
      'escape': {type: Boolean, default: true},
      'content-class': {
        type: String,
        default: 'c-toggle__content'
      },
      'arrow-icon': {
        type: Boolean,
        default: true
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import "~@/assets/scss/private";

  .c-toggle__content {
    position: absolute;
    top: calc(100% + #{em($global-spacing-unit-small)});
    right: 0;
    background-color: white;
    color: $color-base;
    padding: em($global-spacing-unit);
    min-width: 200px;
    width: 100%;
    box-shadow: 0 0 14px rgba(0, 0, 0, .25);
    z-index: 10;

    &:after {
      $width: 5px;
      $height: 5px;
      position: absolute;
      content: '';
      top: -$height;
      right: em($global-spacing-unit);
      width: 0;
      height: 0;
      border-left: $width solid transparent;
      border-right: $width solid transparent;
      border-bottom: $height solid white;
    }
  }

  .c-toggle__button {
    display: flex;
    align-items: center;
    padding: em($global-spacing-unit-tiny) em($global-spacing-unit);
    border: none;
    font-weight: $normal;
    text-transform: none;

    > * {
      &:not(:last-child) {
        margin-right: em($global-spacing-unit-tiny);
      }
    }

    @include down($desktop) {
      margin: auto;
      padding: em($global-spacing-unit-tiny / 2) em($global-spacing-unit / 2);
    }
  }

  /**
   * Header toggle
   */
  .c-toggle--header {
    height: 100%;
    background-color: transparent;
    color: white;
    border-left: 1px solid lighten($color-base, 10%);
    border-right: 1px solid lighten($color-base, 10%);
  }

  .account-content {
    padding: 0;
  }

  .account-button {
    border: 2.5px solid $color-alpha;
    border-radius: 9999px;
    margin: em($global-spacing-unit-tiny);
    padding-left: em($global-spacing-unit-small);
    padding-right: em($global-spacing-unit-small);
    color: $color-white;
    background-color: transparent;
    font-weight: 500;

    span {
      margin-right: em($global-spacing-unit-small);
    }
  }

  .account-button:focus {
    box-shadow: none !important;
    border: 2.5px solid $color-white;
  }

  @include down(1100px) {
    .c-icon-label__content {
      display: none;
    }
    .c-icon-label {
      svg {
        margin-right: em($global-spacing-unit-tiny);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Toggle.vue